import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UrlBuilder } from '../../web/core';
import { TabCategory } from '../../web/documents';
import { ActivatedRoute } from '@angular/router';
import { findUser } from '../shared/route-helpers';

@Component({
    selector: 'user-settings-tabbed',
    template: require('../../web/shared/tabs.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSettingsTabbedComponent {
    public tabsCategories: Observable<TabCategory[]>;

    constructor(
        urlBuilder: UrlBuilder,
        route: ActivatedRoute
    ) {
        const user = findUser(route.snapshot);
        const userId = user.metadata.userId;
        const tabsCategories = [
            {
                name: 'General',
                url: urlBuilder
                    .esa()
                    .globalPopup()
                    .userGeneralSettings(userId)
                    .url()
            }
        ];

        if (user.isSponsorOrInvestigator) {
            tabsCategories.push(
                {
                    name: 'Email Preferences',
                    url: urlBuilder
                        .esa()
                        .globalPopup()
                        .userEmailSettings(userId)
                        .url()
                });
        }

        this.tabsCategories = of(tabsCategories);
    }

}
